import { Component } from '@angular/core';

/**
 * Empty placeholder component for the /digitize route.
 * AppComponent detects this route and renders its existing
 * digitization workflow inline (stepper + steps + action buttons).
 * This component intentionally renders nothing.
 */
@Component({
  selector: 'app-digitize-placeholder',
  template: ''
})
export class DigitizePlaceholderComponent {}
